import React, { useEffect } from "react";
import "./styles.css";
import ImgLoading from "../../assets/styles/imgs/ifpb-loading.svg";

const Loading = (props) => {
    useEffect(() => {
        Loading.loading(false);
    }, []);

    return (
        <div>
            <div id="loading">
                <img id="ifpb-logo" src={ImgLoading} alt="Loading" />
            </div>
        </div>
    );
};

Loading.loading = (show = true) => {
    const loadingElement = document.querySelector('#loading');
    const logoElement = document.querySelector('#ifpb-logo');

    if (loadingElement && logoElement) {
        if (show) {
            loadingElement.style.display = 'flex';
            logoElement.style.display = 'block';
        } else {
            loadingElement.style.display = 'none';
            logoElement.style.display = 'none';
        }
    }
};

export default Loading;